<div class="row justify-content-center">
  <div class="col-lg-5">
    <div class="text-center mb-4">
      <h4 class="fw-bold">Create your account</h4>
      <p>Already have an account?
        <a [routerLink]="['/account/login']" class="link-dark text-decoration-none fw-bold">
          Sign in here
        </a>
      </p>
    </div>
    <form [formGroup]="registerForm" (ngSubmit)="submit()" novalidate>

      <div class="form-group mb-3">
        <label class="form-label" for="email">Your Email</label>
        <input type="email" class="form-control" MyInput placeholder="Email" formControlName="email" id="email">
        <my-error controlName="email" errorKey="required">Email is required.</my-error>
        <my-error controlName="email" errorKey="email">Please enter a valid email.</my-error>
      </div>

      <div class="form-group mb-3">
        <label class="form-label" for="shalaId">Shala Darpan (PIS) ID</label>
        <input type="text" class="form-control" MyInput placeholder="Shala Darpan (PIS) ID" formControlName="shalaId"
          id="shalaId">
        <my-error controlName="shalaId" errorKey="required">Shala Darpan (PIS) ID is required.</my-error>
        <my-error controlName="shalaId" errorKey="pattern">Enter valid 10 Or 11 digit Shala Darpan (PIS) ID.</my-error>
      </div>

      <div class="form-group mb-3">
        <label class="form-label" for="phoneNumber">Your Mobile</label>
        <input type="text" class="form-control" MyInput placeholder="Mobile" formControlName="phoneNumber"
          id="phoneNumber">
        <my-error controlName="phoneNumber" errorKey="required">Mobile Number is required.</my-error>
        <my-error controlName="phoneNumber" errorKey="pattern">Entered mobile format is not valid.</my-error>
      </div>

      <div class="form-group mb-3">
        <label class="form-label" for="password">Password</label>
        <input type="password" class="form-control" MyInput placeholder="Password" formControlName="password"
          id="password">
        <my-error controlName="password" errorKey="required">Password is required.</my-error>
        <my-error controlName="password" errorKey="minlength">Password must be at least 6 characters.
        </my-error>
      </div>

      <div class="form-group mb-3">
        <label class="form-label" for="confirmPassword">Confirm Password</label>
        <input type="password" class="form-control" MyInput placeholder="Confirm Password"
          formControlName="confirmPassword" id="confirmPassword">
        <my-error controlName="confirmPassword" errorKey="required">Confirm Password is required.</my-error>
        <div class="invalid-feedback" style="display: block;"
          *ngIf="registerForm.get('confirmPassword').dirty && registerForm.hasError('mismatch')">
          Confirm password must match password
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center my-3">
        <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!registerForm.valid || loading" type="submit">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
          Sign Up
        </button>
        <a [routerLink]="['/account/resend-confirm-link']" class="link-dark text-decoration-none fw-bold">
          Resend Confirmation Link?
        </a>
      </div>
    </form>
  </div>
</div>